import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Admin/Sidebar";
import * as Icon from "react-bootstrap-icons";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import { ToastContainer, toast } from "react-toastify";
import { getAccounts } from "./Allaccounts";
import axios from "axios";
import { Button } from "react-bootstrap";
import { FaFilePdf, FaLock, FaUndo } from "react-icons/fa";
import Pagination from 'react-bootstrap/Pagination';

const Users = () => {
  const [toggleValue, setToggleValue] = useState(false);
  const navigate = useNavigate();
  const [accountStatus, setAccountStatus] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [showUpdate, setShowUpdate] = useState(false);
  const [accountToUpdate, setAccountToUpdate] = useState(null);
  const [activeType, setActiveType] = useState(1);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const handleUpdateClose = () => setShowUpdate(false);

  // Authentication
  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const getData = useCallback(async ({ token, type, status }) => {
    try {
      const response = await getAccounts(token);
      setAccountStatus(response?.status);

      const filteredAccounts = response?.accounts?.filter(
        (account) =>
          account?.userType !== "admin" && account?.isActive === status
      );
      setAccounts(filteredAccounts || []);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  }, []);

  useEffect(() => {
    getData({ token, type: "", status: 1 });
  }, [token, getData]);

  const handleUpdate = (account) => {
    setAccountToUpdate(account);
    setShowUpdate(true);
  };

  const updateStatus = async (isActive) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dashbord/roll_status_change`,
        { uid: accountToUpdate.id, isActive: isActive },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const message = response.data.message;
      const status = response.data.status;
      if (status === "error") {
        toast.warn(message);
      } else {
        toast.success("User status updated successfully");
      }
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  const handleLock = async (isLock) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dashbord/roll_status_change`,
        { uid: accountToUpdate.id, isLock: isLock },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const { message, status } = response.data;

      if (status === "error") {
        toast.warn(message);
      } else {
        toast.success(
          isLock ? "User Locked successfully" : "User Unlocked successfully"
        );
        setAccountToUpdate((prev) => ({
          ...prev,
          isLock: isLock,
        }));
        getData({ token, type: "user", status: activeType });
      }
    } catch (error) {
      toast.error(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const handleReset = async (isReset) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dashbord/roll_status_change`,
        { uid: accountToUpdate.id, isReset: isReset },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const { message, status } = response.data;

      if (status === "error") {
        toast.warn(message);
      } else {
        toast.success(isReset ? "User Will Get Message For Reset Documents" : "documents Aprroved");
        setAccountToUpdate((prev) => ({
          ...prev,
          isReset: isReset,
        }));
        getData({ token, type: "user", status: activeType });
      }
    } catch (error) {
      toast.error(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const handelSave = async () => {
    try {
      handleUpdateClose();
      getData({ token, type: "user", status: activeType });
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  const updateRole = async (userType) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dashbord/roll_status_change`,
        { uid: accountToUpdate.id, userType: userType },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const message = response.data.message;
      const status = response.data.status;
      if (status === "error") {
        toast.warn(message);
      } else {
        // handleUpdateClose()
        toast.success("User status updated successfully");
        // getData({ token, type: 'user', status: activeType })
      }
    } catch (error) {
      toast.error("Error:", error);
    }
  };

  const handlePdfOpen = (url) => {
    setPdfUrl(url);
    setShowPdfModal(true);
  };

  const closeModel = () => {
    setShowPdfModal(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  // Pegination logic
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setTotalPages(Math.ceil(accounts.length / itemsPerPage));
  }, [accounts, itemsPerPage]);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAccounts = accounts.slice(indexOfFirstItem, indexOfLastItem);

  const renderPaginationItems = () => {
    const items = [];

    // Always show the first page
    items.push(
      <Pagination.Item key={1} active={currentPage === 1} onClick={() => handlePageClick(1)}>
        1
      </Pagination.Item>
    );

    // Show ellipsis if currentPage > 3
    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    // Show currentPage -1, currentPage, currentPage +1 (if within range)
    for (let page = currentPage - 1; page <= currentPage + 1; page++) {
      if (page > 1 && page < totalPages) {
        items.push(
          <Pagination.Item key={page} active={currentPage === page} onClick={() => handlePageClick(page)}>
            {page}
          </Pagination.Item>
        );
      }
    }

    // Show ellipsis if currentPage < totalPages - 2
    if (currentPage < totalPages - 2) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    // Always show the last page (if not already shown)
    if (totalPages > 1) {
      items.push(
        <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => handlePageClick(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 p-0">
            <Sidebar
              toggleSidebar={toggleValue}
              setToggleValue={setToggleValue}
            />
          </div>
          <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
            <Icon.ArrowRight
              onClick={() => setToggleValue(true)}
              className="my-5 sidebar-open"
              color="black"
              size={30}
            ></Icon.ArrowRight>
            <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
              <div className="col-12 mb-4">
                <h5>Accounts</h5>
                <h6 className="text-muted">View & manage accounts</h6>
              </div>
              {/* Tabs start */}
              <div className="col-12 mb-3">
                {/* Tabs start */}
                <ul className="nav nav-pills">
                  <li className="nav-item border border-1 rounded">
                    <button
                      className={`btn ${activeType === 1 && "active"}`}
                      onClick={() => {
                        getData({ token, type: "user", status: 1 });
                        setActiveType(1);
                        setCurrentPage(1);
                      }}
                    >
                      Active
                    </button>
                  </li>
                  <li className="nav-item border border-1 ms-2 rounded">
                    <button
                      className={`btn ${activeType === 2 && "active"}`}
                      onClick={() => {
                        getData({ token, type: "user", status: 2 });
                        setActiveType(2);
                        setCurrentPage(1);
                      }}
                    >
                      Pending
                    </button>
                  </li>
                  <li className="nav-item border border-1 ms-2 rounded">
                    <button
                      className={`btn ${activeType === 0 && "active"}`}
                      onClick={() => {
                        getData({ token, type: "user", status: 0 });
                        setActiveType(0);
                        setCurrentPage(1);
                      }}
                    >
                      Inactive
                    </button>
                  </li>
                </ul>
                {/* Tabs end */}
              </div>

              <div className="col-12">
                {/* Table start */}
                <Table striped bordered hover responsive="md">
                  <thead className="text-center">
                    <tr className="text-center">
                      <th>ID</th>
                      <th>Picture</th>
                      <th>Name</th>
                      <th>Email id</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      accountStatus === "success"
                        ?
                        currentAccounts.length > 0
                          ?
                          (
                            currentAccounts.map((account, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  <img
                                    className="order-list-product-image"
                                    src={`${process.env.REACT_APP_API_URL +
                                      process.env.REACT_APP_profile_IMAGE_URL +
                                      account.profilePhoto
                                      }`}
                                    alt={account?.name}
                                  />
                                </td>
                                <td>{account?.name}</td>
                                <td>{account?.email}</td>
                                <td>{account?.userType}</td>
                                <td className="text-center">
                                  {account.isActive === 1 ? (
                                    <span className="badge rounded-pill text-bg-success">
                                      Active
                                    </span>
                                  ) : account.isActive === 2 ? (
                                    <span className="badge rounded-pill text-bg-warning">
                                      Pending
                                    </span>
                                  ) : (
                                    <span className="badge rounded-pill text-bg-secondary">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  <button
                                    onClick={() => handleUpdate(account)}
                                    className="btn btn-sm btn-warning"
                                  >
                                    <Icon.Pencil />
                                  </button>
                                </td>
                              </tr>
                            ))
                          )
                          :
                          (
                            <tr>
                              <td colSpan="7" className="text-center p-5">
                                <span>No Users Available</span>
                              </td>
                            </tr>
                          )
                        :
                        (
                          <tr>
                            <td colSpan="7" className="text-center p-5">
                              <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </Spinner>
                            </td>
                          </tr>
                        )
                    }
                  </tbody>
                </Table>
                {/* Table end */}
              </div>

              {/* Pagination controls */}
              {
                currentAccounts.length > 0 &&
                <div className="col-12 d-flex justify-content-center mt-2">
                  <Pagination>
                    <Pagination.First onClick={() => handlePageClick(1)} disabled={currentPage === 1} />
                    <Pagination.Prev onClick={() => handlePageClick(currentPage - 1)} disabled={currentPage === 1} />

                    {renderPaginationItems()}

                    <Pagination.Next onClick={() => handlePageClick(currentPage + 1)} disabled={currentPage === totalPages} />
                    <Pagination.Last onClick={() => handlePageClick(totalPages)} disabled={currentPage === totalPages} />
                  </Pagination>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      {/* Account Update Modal */}
      <Modal
        show={showUpdate}
        onHide={handleUpdateClose}
        size="lg"
        key={accountToUpdate ? accountToUpdate.id : "modal"}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {/* <Icon.PencilSquare color='black' size={40} /> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {accountToUpdate && (
            <Container>
              <Row>
                <Col xs={8} md={4}>
                  <Image
                    style={{ borderRadius: "50%", width: "200px", height: "200px", objectFit: "cover" }}
                    src={`${process.env.REACT_APP_API_URL +
                      process.env.REACT_APP_profile_IMAGE_URL +
                      accountToUpdate.profilePhoto
                      }`}
                    fluid
                    className="img-fluid border border-3"
                    onError={(e) => {
                      e.target.src =
                        "https://pronedvizhimost.ru/static/custom/img/default/user.png";
                    }}
                  />
                </Col>
                <Col xs={4} md={8}>
                  <h5>
                    Name:<span className="ms-2">{accountToUpdate.name}</span>
                  </h5>
                  <h6 className="text-dark">
                    Email:<span className="ms-2">{accountToUpdate?.email}</span>
                  </h6>
                  <h6 className="text-muted">
                    Role:
                    <span className="ms-2">{accountToUpdate?.userType}</span>
                  </h6>
                  <section className="mt-4 border border-2 p-2 rounded d-flex flex-column">
                    <h6>Address:</h6>
                    <span className="ms-0">
                      {accountToUpdate.userInfo
                        ? "City: " +
                        accountToUpdate?.userInfo?.city +
                        ",  " +
                        "State: " +
                        accountToUpdate?.userInfo?.state +
                        ",  " +
                        "Zip Code: " +
                        accountToUpdate?.userInfo?.zip +
                        ",  " +
                        "Full Address: " +
                        accountToUpdate?.userInfo?.address +
                        ",  " +
                        "Phone no: " +
                        accountToUpdate?.userInfo?.number
                        : "Address is empty"}
                    </span>
                  </section>
                  <Row className="mt-4">
                    <Col xs={6} md={6}>
                      <p>
                        <strong>Bank Name :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.bankName
                            ? accountToUpdate?.userInfo?.bankName
                            : "Bank name is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <p>
                        <strong>Branch Name :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.branchName
                            ? accountToUpdate?.userInfo?.branchName
                            : "Branch name is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <p>
                        <strong>IFSC Code :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.ifscCode
                            ? accountToUpdate?.userInfo?.ifscCode
                            : "IFSC code is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <p>
                        <strong>Account No :</strong>
                        <span className="ms-2">
                          {accountToUpdate?.userInfo?.accountNumber
                            ? accountToUpdate?.userInfo?.accountNumber
                            : "Account Number is empty"}
                        </span>
                      </p>
                    </Col>
                    <Col xs={6} md={6}>
                      <strong className="mb-1 d-block">Bank Statement</strong>
                      {accountToUpdate?.userInfo?.bankFile !== "N/A" ? (
                        <Button
                          variant="outline-primary"
                          onClick={() =>
                            handlePdfOpen(
                              `${process.env.REACT_APP_API_URL}src/upload/bankfile/${accountToUpdate?.userInfo?.bankFile}`
                            )
                          }
                        >
                          <FaFilePdf className="me-2" /> Bank file
                        </Button>
                      ) : (
                        <span className="text-muted">No file available</span>
                      )}
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Row className="mt-4">
                      <Row>
                        <Col xs={12} md={12}>
                          <h6>
                            Aadhar No:
                            <span className="ms-2 text-muted">
                              {accountToUpdate?.userInfo?.aadharNumber
                                ? accountToUpdate?.userInfo.aadharNumber
                                : "No is empty"}
                            </span>
                          </h6>
                          <Row>
                            <Col xs={6} md={6}>
                              {accountToUpdate?.userInfo?.aadharfrontFile !==
                                "N/A" ? (
                                <Button
                                  variant="outline-primary"
                                  onClick={() =>
                                    handlePdfOpen(
                                      `${process.env.REACT_APP_API_URL}src/upload/aadharfile/${accountToUpdate?.userInfo?.aadharfrontFile}`
                                    )
                                  }
                                >
                                  <FaFilePdf className="me-2" /> Aadhar front
                                </Button>
                              ) : (
                                <span className="text-muted">
                                  No file available
                                </span>
                              )}
                            </Col>
                            <Col xs={6} md={6}>
                              {accountToUpdate?.userInfo?.aadharbackFile !==
                                "N/A" ? (
                                <Button
                                  variant="outline-primary"
                                  onClick={() =>
                                    handlePdfOpen(
                                      `${process.env.REACT_APP_API_URL}src/upload/aadharfile/${accountToUpdate?.userInfo?.aadharbackFile}`
                                    )
                                  }
                                >
                                  <FaFilePdf className="me-2" /> Aadhar back
                                </Button>
                              ) : (
                                <span className="text-muted">
                                  No file available
                                </span>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <Col xs={6} md={6}>
                          <h6>
                            Pan No:
                            <span className="ms-2 text-muted">
                              {accountToUpdate?.userInfo?.panNumber
                                ? accountToUpdate?.userInfo.panNumber
                                : "No is empty"}
                            </span>
                          </h6>
                          {accountToUpdate?.userInfo?.panFile !== "N/A" ? (
                            <Button
                              variant="outline-primary"
                              onClick={() =>
                                handlePdfOpen(
                                  `${process.env.REACT_APP_API_URL}src/upload/panfile/${accountToUpdate?.userInfo?.panFile}`
                                )
                              }
                            >
                              <FaFilePdf className="me-2" /> Pan file
                            </Button>
                          ) : (
                            <span className="text-muted">
                              No file available
                            </span>
                          )}
                        </Col>
                      </Row>
                    </Row>
                    <Row className="mt-3">
                      <Col xs={6} md={6}>
                        <h6>Change Status</h6>
                        <select
                          onChange={(e) => updateStatus(e.target.value)}
                          className="form-select shadow-none"
                          aria-label="Default select example"
                        >
                          {accountToUpdate.isActive === 1 && (
                            <option selected disabled>
                              Active
                            </option>
                          )}
                          {accountToUpdate.isActive === 2 && (
                            <option selected disabled>
                              Pending
                            </option>
                          )}
                          {accountToUpdate.isActive === 0 && (
                            <option selected disabled>
                              Inactive
                            </option>
                          )}
                          <option value="1">Active</option>
                          <option value="2">Pending</option>
                          <option value="0">Inactive</option>
                        </select>
                      </Col>
                      <Col xs={6} md={6}>
                        <h6>Change Role</h6>
                        <select
                          onChange={(e) => updateRole(e.target.value)}
                          className="form-select shadow-none"
                          aria-label="Default select example"
                        >
                          <option selected disabled>
                            {accountToUpdate?.userType}
                          </option>
                          <option value="admin">admin</option>
                          <option value="user">user</option>
                          <option value="distributor">distributor</option>
                        </select>
                      </Col>
                    </Row>
                  </Row>
                </Col>
                <div style={{ textAlign: "right", marginTop: "15px" }}>
                  <Button
                    variant={
                      accountToUpdate?.isLock
                        ? "outline-danger"
                        : "outline-success"
                    }
                    onClick={() => handleLock(accountToUpdate?.isLock ? 0 : 1)}
                  >
                    <FaLock className="me-2" />{" "}
                    {accountToUpdate?.isLock ? "Unlock" : "Lock"}
                  </Button>
                  <Button
                    className="ms-2"
                    variant={
                      accountToUpdate?.isLock
                        ? "outline-warning"
                        : "outline-secondary"
                    }
                    onClick={() =>
                      handleReset(accountToUpdate?.isReset ? 0 : 1)
                    }
                  >
                    <FaUndo className="me-2" />{" "}
                    {accountToUpdate?.isReset ? "Reset" : "Disabled"}
                  </Button>
                  <Button
                    className="ms-2"
                    variant="success"
                    onClick={handelSave}
                  >
                    Save
                  </Button>
                </div>
              </Row>
            </Container>
          )}
        </Modal.Body>
      </Modal>

      {/* Show pdf modal */}
      <Modal show={showPdfModal} onHide={closeModel} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>PDF Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={pdfUrl}
            width="100%"
            height="500px"
            style={{ border: "none" }}
            title="PDF Viewer"
          ></iframe>
        </Modal.Body>
      </Modal>

      <ToastContainer theme="dark" autoClose={2000} />
    </>
  );
};

export default Users;
